import {combineReducers} from "@reduxjs/toolkit";
import EditorReducer from "../pages/editor/editorSlice";
import  CdsReducer from "../pages/libraries/cdsSlice";
import {apiSlice} from "./apiSlice";
import app from "./appSlice";
import TreatmentReducer from "../pages/treatments/TreatmentSlice";

export const rootReducer = combineReducers({
    editor: EditorReducer,
    app: app,
    cds : CdsReducer,
    treatment: TreatmentReducer,
    [apiSlice.reducerPath]: apiSlice.reducer
})
